import CoreBase from '../../../services/engines/CoreBase';
import gatewayService from '../../../services/GatewayService';
import responseHelper from '../../../services/ResponseHelper';

const _name = 'YourDataFetcher';
const PAGE_SIZE = 25;

/**
 * Fetches entries for a topic from the API.
 * No cache, no state, no side effects beyond the HTTP call.
 * Returns { entries, total, page } on success, null on failure.
 */
class YourDataFetcher extends CoreBase {
    /**
     * Fetches and sorts a page of entries for a topic.
     * @param {string} topic - Topic name or '__recent__'
     * @param {number} page - Page number, defaults to 1
     * @returns {Promise<{entries: object[], total: number, page: number}|null>}
     */
    fetch = async (topic, page = 1) => {
        try {
            const resp = await gatewayService.getUserEntries(topic, page, PAGE_SIZE);
            if (responseHelper.check(resp, '', `${_name}.fetch`) < 0) {
                return null;
            }

            const items = resp.data.items;
            const r = {
                entries: items,
                size: resp.data.pageSize,
                total: resp.data.totalItems,
                page: resp.data.pageNum,

                pages: resp.data.totalPages,
            };

            return r;
        } catch (error) {
            this.logError('fetch', error.message);
            return null;
        }
    };
}

const yourDataFetcher = new YourDataFetcher();
export default yourDataFetcher;
